import React, { useState } from "react";
import Iframe from "react-iframe";
import { InlineMath } from "react-katex";
const GS4 = () => {
	const [styleno1, setStyleno1] = useState({ width: "40px" });
	const [styleno2, setStyleno2] = useState({ width: "40px" });
	const [styleno4, setStyleno4] = useState({ width: "60px" });

	const handleX = (x) => {
		const jwb = x.target.value;
		jwb === "150"
			? setStyleno1({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno1({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno1({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleY = (y) => {
		const jwb = y.target.value;
		jwb === "100"
			? setStyleno2({
					width: "50px",
					border: "6px solid #1aff66",
			  })
			: jwb === ""
			? setStyleno2({
					width: "50px",
					border: "6px solid yellow",
			  })
			: setStyleno2({
					width: "50px",
					border: "6px solid red",
			  });
	};
	const handleUph = (upah) => {
		const jwb = upah.target.value;
		if(jwb === "950000"){
			 setStyleno4({
					width: "150px",
					border: "6px solid #1aff66",
			  })
			setShownext(true)
		  } else if( jwb === "" ){
			setStyleno4({
					width: "150px",
					border: "6px solid yellow",
			  })
			} else {setStyleno4({
					width: "150px",
					border: "6px solid red",
			  });
			}
	};
	const [show1,setShow1] = useState(false);
	const [show2,setShow2] = useState(false);
	const [show3,setShow3] = useState(false);
	const [show4,setShow4] = useState(false);
	const [show5,setShow5] = useState(false);
	const [show6,setShow6] = useState(false);
	const [form1, setForm1] = useState({ width: "50px", height: "30px" });
	const [form2, setForm2] = useState({ width: "50px", height: "30px" });
	const [form3, setForm3] = useState({ width: "50px", height: "30px" });
	const [form4, setForm4] = useState({ width: "50px", height: "30px" });
	const [form5, setForm5] = useState({ width: "50px", height: "30px" });
	const [form6, setForm6] = useState({ width: "50px", height: "30px" });
	const handleform1 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "2") {
			setForm1({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShow1(true)
		} else if (jwb === "") {
			setForm1({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm1({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform2 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "5") {
			setForm2({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShow2(true)
		} else if (jwb === "") {
			setForm2({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm2({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform3 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "800") {
			setForm3({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShow3(true)
		} else if (jwb === "") {
			setForm3({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm3({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform4 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "2") {
			setForm4({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShow4(true)
		} else if (jwb === "") {
			setForm4({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm4({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform5 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "1") {
			setForm5({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShow5(true)
		} else if (jwb === "") {
			setForm5({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm5({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform6 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "400") {
			setForm6({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShow6(true)
		} else if (jwb === "") {
			setForm6({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm6({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};

		
	//1maret22
	const [form7, setForm7] = useState({ width: "50px", height: "30px" });
	const [form8, setForm8] = useState({ width: "50px", height: "30px" });
	const [form9, setForm9] = useState({ width: "50px", height: "30px" });
	const [form10, setForm10] = useState({ width: "50px", height: "30px" });
	const [form11, setForm11] = useState({ width: "50px", height: "30px" });
	const [form12, setForm12] = useState({ width: "50px", height: "30px" });
	const [form13, setForm13] = useState({ width: "70px", height: "30px" });
	const [form14, setForm14] = useState({ width: "70px", height: "30px" });
	const [show7,setShow7] = useState(false);
	const [show8,setShow8] = useState(false);
	const [show9,setShow9] = useState(false);
	const [show10,setShow10] = useState(false);
	const [show11,setShow11] = useState(false);
	const [show12,setShow12] = useState(false);
	const [show13,setShow13] = useState(false);
	const [show14,setShow14] = useState(false);
	const [form15, setForm15] = useState({ width: "50px", height: "30px" });
	const [form16, setForm16] = useState({ width: "50px", height: "30px" });
	const [form17, setForm17] = useState({ width: "50px", height: "30px" });
	const [form18, setForm18] = useState({ width: "50px", height: "30px" });
	const [form19, setForm19] = useState({ width: "50px", height: "30px" });
	const [form20, setForm20] = useState({ width: "50px", height: "30px" });
	const [form21, setForm21] = useState({ width: "70px", height: "30px" });
	const [form22, setForm22] = useState({ width: "70px", height: "30px" });
	const [form23, setForm23] = useState({ width: "50px", height: "30px" });
	const [form24, setForm24] = useState({ width: "50px", height: "30px" });
	const [show15,setShow15] = useState(false);
	const [show16,setShow16] = useState(false);
	const [show17,setShow17] = useState(false);
	const [show18,setShow18] = useState(false);
	const [show19,setShow19] = useState(false);
	const [show20,setShow20] = useState(false);
	const [show21,setShow21] = useState(false);
	const [show22,setShow22] = useState(false);
	const [show23,setShow23] = useState(false);
	const [show24,setShow24] = useState(false);
	const [shownext,setShownext] = useState(false);
	const handleform7 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "400") {
			setForm7({
				border: "6px solid #1aff66",
				width: "55px",
				height: "30px",
			})
			setShow7(true)
		} else if (jwb === "") {
			setForm7({
				border: "6px solid yellow",
				width: "55px",
				height: "30px",
			});
		} else {
			setForm7({
				border: "6px solid red",
				width: "55px",
				height: "30px",
			});
		}
	};
	const handleform8 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setForm8({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShow8(true)
		} else if (jwb === "") {
			setForm8({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm8({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform9 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "400,0") {
			setForm9({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			})
			setShow9(true)
		} else if (jwb === "") {
			setForm9({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setForm9({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handleform10 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setForm10({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShow10(true)
		} else if (jwb === "") {
			setForm10({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm10({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform11 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "160") {
			setForm11({
				border: "6px solid #1aff66",
				width: "55px",
				height: "30px",
			})
			setShow11(true)
		} else if (jwb === "") {
			setForm11({
				border: "6px solid yellow",
				width: "55px",
				height: "30px",
			});
		} else {
			setForm11({
				border: "6px solid red",
				width: "55px",
				height: "30px",
			});
		}
	};
	const handleform12 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0,160") {
			setForm12({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			})
			setShow12(true)
		} else if (jwb === "") {
			setForm12({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setForm12({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handleform13 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "400,0") {
			setForm13({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			})
			setShow13(true)
		} else if (jwb === "") {
			setForm13({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setForm13({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handleform14 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0,160") {
			setForm14({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			})
			setShow14(true)
		} else if (jwb === "") {
			setForm14({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setForm14({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};

	const handleform15 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "200") {
			setForm15({
				border: "6px solid #1aff66",
				width: "55px",
				height: "30px",
			})
			setShow15(true)
		} else if (jwb === "") {
			setForm15({
				border: "6px solid yellow",
				width: "55px",
				height: "30px",
			});
		} else {
			setForm15({
				border: "6px solid red",
				width: "55px",
				height: "30px",
			});
		}
	};
	const handleform16 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setForm16({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShow16(true)
		} else if (jwb === "") {
			setForm16({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm16({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform17 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "200,0") {
			setForm17({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			})
			setShow17(true)
		} else if (jwb === "") {
			setForm17({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setForm17({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handleform18 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setForm18({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShow18(true)
		} else if (jwb === "") {
			setForm18({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm18({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform19 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "400") {
			setForm19({
				border: "6px solid #1aff66",
				width: "55px",
				height: "30px",
			})
			setShow19(true)
		} else if (jwb === "") {
			setForm19({
				border: "6px solid yellow",
				width: "55px",
				height: "30px",
			});
		} else {
			setForm19({
				border: "6px solid red",
				width: "55px",
				height: "30px",
			});
		}
	};
	const handleform20 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0,400") {
			setForm20({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			})
			setShow20(true)
		} else if (jwb === "") {
			setForm20({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setForm20({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handleform21 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "200,0") {
			setForm21({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			})
			setShow21(true)
		} else if (jwb === "") {
			setForm21({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setForm21({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handleform22 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0,400") {
			setForm22({
				border: "6px solid #1aff66",
				width: "70px",
				height: "30px",
			})
			setShow22(true)
		} else if (jwb === "") {
			setForm22({
				border: "6px solid yellow",
				width: "70px",
				height: "30px",
			});
		} else {
			setForm22({
				border: "6px solid red",
				width: "70px",
				height: "30px",
			});
		}
	};
	const handleform23 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "3") {
			setForm23({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShow23(true)
		} else if (jwb === "") {
			setForm23({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm23({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform24 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "5") {
			setForm24({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
			setShow24(true)
		} else if (jwb === "") {
			setForm24({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm24({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	//1maret22
	return (
		<div className="container">
			<div className="card border-primary shadow  bg-body rounded  mt-2 mb-2">
				<div className="card-body">
					<p
						style={{
							lineHeight: "35px",
							textAlign: "justify",
							textIndent: "2rem",
						}}
					>
						Seorang pembuat kue mempunyai 8 kg tepung dan 2 kg gula pasir. Ia
						ingin membuat dua macam kue yaitu kue dadar dan kue apem. Untuk
						membuat kue dadar dibutuhkan 10 gram gula pasir dan 20 gram tepung
						sedangkan untuk membuat sebuah kue apem dibutuhkan 5 gram gula pasir
						dan 50 gram tepung. Jika kue dadar dijual dengan harga Rp
						3.000,00/buah dan kue apem dijual dengan harga Rp 5.000,00/buah,
						dengan memisalkan banyaknya kue dadar adalah x dan banyaknya kue
						apem adalah y.tentukanlah pendapatan maksimum yang dapat diperoleh
						pembuat kue tersebut...
					</p>
				</div>
			</div>
			<div className="text-center alert alert-warning h6 mt-2" >Jawaban</div>
			<ol>
			<li>Dengan memisalkan <InlineMath math=" x " />adalah banyaknya kue dadar dan <InlineMath math=" y "/>adalah banyaknya kue apem</li>
			<li>Maka kita buat ke dalam bentuk pertidaksamaan :</li>
			<ul>
				<li>Pada bahan tepung</li>
				<li><InlineMath math="20x + 50y ≤ 8000 "/> &nbsp; Agar
										memudahkan kita, coba kalian sederhanakan dengan membagi semua koefisien dan
										konstanta dengan 10</li>
				<li><input type="text" style={form1} onChange={handleform1} /><InlineMath math="x +"/><input type="text" style={form2} onChange={handleform2}/><InlineMath math="y ≤ "/><input type="text" style={form3} onChange={handleform3} /></li>
{show1&&show2&&show3?
<>
<p className="text-center">Selanjutnya mencari titik potong pada sumbu <InlineMath math="\space x \space" /> dan titik potong pada sumbu <InlineMath math="\space y \space" /> pada <InlineMath math="\space 2x + 5y = 800"/></p>
	<table
	style={{
	width: "100%",
	textAlign: "center",
	}}
	className="table"
	>
	<tr>
	<th
	style={{
	border: "2px solid green",
	}}>
																						x
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						y
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						(x,y)
																					</th>
																				</tr>
																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						<input
																							type="text"
																							onChange={handleform7}
																							style={form7}
																						/>
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						<input
																							type="text"
																							onChange={handleform8}
																							style={form8}
																						/>
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>(
																						<input
																							type="text"
																							onChange={handleform9}
																							style={form9}
																						/>
																					)
																					</td>
																				</tr>
																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						<input
																							type="text"
																							onChange={handleform10}
																							style={form10}
																						/>
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						<input
																							type="text"
																							onChange={handleform11}
																							style={form11}
																						/>
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>(
																						<input
																							type="text"
																							onChange={handleform12}
																							style={form12}
																						/>
																					)
																					</td>
																				</tr>
	</table>	
{show7&&show8&&show9&&show10&&show11&&show12?
<>
<p className="text-center mt-2 mb-2">Maka kita dapatkan :</p>
																	<div className="d-flex justify-content-center">
																		Titik Koordinat A = (<input type="text" onChange={handleform13} style={form13} />) 
																	</div>
																	<div className="d-flex justify-content-center">
																		Titik Koordinat B = (<input type="text" onChange={handleform14} style={form14} />) 
																	</div>

{show13&&show14?
<>
<li>Pada bahan gula pasir</li>
<li><InlineMath math="10x + 5y ≤ 2000 "/> &nbsp; Agar
						memudahkan kita, coba kalian sederhanakan dengan membagi semua koefisien dan
						konstanta dengan 5</li>
<li><input type="text" style={form4} onChange={handleform4} /><InlineMath math="x +"/><input type="text" style={form5} onChange={handleform5}/><InlineMath math="y ≤ "/><input type="text" style={form6} onChange={handleform6} /></li>
{show4&&show5&&show6?
<>
<p className="text-center mt-2 mb-2">Selanjutnya mencari titik potong pada sumbu <InlineMath math="\space x \space" /> dan titik potong pada sumbu <InlineMath math="\space y \space" /> pada <InlineMath math="\space 2x + y = 400"/></p>
	<table
	style={{
	width: "100%",
	textAlign: "center",
	}}
	className="table"
	>
	<tr>
	<th
	style={{
	border: "2px solid green",
	}}>
																						x
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						y
																					</th>
																					<th
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						(x,y)
																					</th>
																				</tr>
																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						<input
																							type="text"
																							onChange={handleform15}
																							style={form15}
																						/>
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						<input
																							type="text"
																							onChange={handleform16}
																							style={form16}
																						/>
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>(
																						<input
																							type="text"
																							onChange={handleform17}
																							style={form17}
																						/>
																					)
																					</td>
																				</tr>
																				<tr>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						<input
																							type="text"
																							onChange={handleform18}
																							style={form18}
																						/>
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>
																						<input
																							type="text"
																							onChange={handleform19}
																							style={form19}
																						/>
																					</td>
																					<td
																						style={{
																							border: "2px solid green",
																						}}
																					>(
																						<input
																							type="text"
																							onChange={handleform20}
																							style={form20}
																						/>
																					)
																					</td>
																				</tr>
	</table>	
{show15&&show16&&show17&&show18&&show19&&show20?
<>
<p className="text-center">Maka kita dapatkan :</p>
																	<div className="d-flex justify-content-center">
																		Titik Koordinat C = (<input type="text" onChange={handleform21} style={form21} />) 
																	</div>
																	<div className="d-flex justify-content-center">
																		Titik Koordinat D = (<input type="text" onChange={handleform22} style={form22} />) 
																	</div>
{show21&&show22?
<>
<li>Karena tidak mungkin banyaknya kue dadar dan kue apem itu negatif, maka <InlineMath math=" x ≥ 0" /> dan <InlineMath math=" y ≥ 0 " /> </li>
<div className="d-flex justify-content-center">
<li>Lalu masukkan fungsi objektif yang sudah disederhanakan dengan membagi nilai konstanta dengan 1000, maka <InlineMath math="\space z = " /><input type="text" onChange={handleform23} style={form23} /><InlineMath math="x \space + " /><input type="text" onChange={handleform24} style={form24} /><InlineMath math="y \space " /> </li> 
</div>
{show23&&show24?
<>
<div className="text-center alert alert-warning"> 
<p className="mb-1">Selanjutnya kerjakan yang ada pda grafik.</p>
<b>Petunjuk :</b> Kalian dapat melakukan zoom pada grafik.
</div>

<div className="d-flex justify-content-center">
<Iframe
 scrolling="no" title="gs4_12_03_22" src="https://www.geogebra.org/material/iframe/id/khmzcujv/width/900/height/800/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false" width="900px" height="800px" allowFullScreen
/>
</div>
<div className="d-flex justify-content-center">
<div className="mt-1">
	<div>
		<p>Masukkan nilai x dan y pada titik minimumnya</p>
		<InlineMath math=" x = \space" /><input type="text" style={styleno1} onChange={handleX} />
		&nbsp;
		<InlineMath math=" y = \space" /><input type="text" style={styleno2} onChange={handleY} />
	</div>

	<div>
		<p>Masukkan pendapatan maksimum</p>
		<p>
			Rp &nbsp;&nbsp;
			<input type="number" style={styleno4} onChange={handleUph} />
		</p>
	</div>
</div>
</div>
{shownext?
<>
<div className="text-center alert alert-success"> Yeay kamu benar, Ayo kerjakan soal berikutnya dengan menekan tombol next di bawah !</div>
</>
:null}
</>
:null}
</>
:null}
</>
:null}

</>:null}
</>
:null}
</>
:null}
</>
:null}

</ul>
			</ol>
		</div>
	);
};

export default GS4;
